import React, { Component } from "react";
import Table from "../../../../components/table";
import "./style.scss";
import { connect } from "react-redux";
import { getPlayerBatter, converdataDeregis, convertDataAchievement } from './../../../../actions/player-batter';
import { converTrouble, convertDataPerformance } from './../../../../actions/player-pitchers';
import Loading from "../../../../components/loading";
import { CardGrid, CardChart } from '../../../../components/chart';
import { LIST_VIEW, LINE_CHART_VIEW, COLUMN_CHART_VIEW } from '../../../../components/chart/card-chart';
import { GRID, CIRCLE } from '../../../../components/chart/card-grid';
import { 
    getPlayerPitcherBallTypePerformances,
    getPlayerPitcherOrdinaryHitsSummaries,
    getPlayerBatterHotzone,
    getPlayerBatterBattedBallDirection
} from '../../../../actions/player-search';

class BasicInfomation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDropdown: false,
            infomation1: '',
            infomation2: '',
            isShowChart1: true,
            checked: false,
            dataDeregis: [],
            dataAchievement: [],
            dataChart1: [],
            dataChart2: [],
            showLoading: false,
            playerInfo: null,
            position: '',
            listYear:[]
        }
    }

    onChangeDataInput(event) {
        let name = event.target.name
        let value = event.target.value
        this.setState({
            [name]: value
        })
    }

    changeChart(e, i) {
        if (!i) {
            e.target.style.backgroundColor = '#3D3DF2';
            e.target.style.color = 'white';
            e.target.style.border = '1px solid #3D3DF2';
            e.target.parentNode.lastChild.style.backgroundColor = 'transparent';
            e.target.parentNode.lastChild.style.color = '#444444';
            e.target.parentNode.lastChild.style.border = '1px solid #D1D9DE';
            this.setState({
                isShowChart1: true
            });
        } else {
            e.target.style.backgroundColor = '#3D3DF2';
            e.target.style.color = 'white';
            e.target.style.border = '1px solid #3D3DF2';
            e.target.parentNode.firstChild.style.backgroundColor = 'transparent';
            e.target.parentNode.firstChild.style.color = '#444444';
            e.target.parentNode.firstChild.style.border = '1px solid #D1D9DE';

            this.setState({
                isShowChart1: false
            });
        }
    }

    // deleteCheckChart = (e, i) => {
    //     const allCheckbox = document.getElementsByClassName('checkChart');
    //     for (let index = 0; index < allCheckbox.length; index++) {
    //         allCheckbox[index].setAttribute('disabled', true);

    //     }
    //     e.target.removeAttribute('disabled');
    //     e.target.setAttribute('checked', true);
    // }

    // componentDidMount = () => {
    //     const right = document.getElementById('right');
    //     right.setAttribute('checked', true);

    // }

    handleCheck(e, text) {
        if (text === 'left') {
            if (document.getElementById('left').checked) {
                document.getElementById('right').checked = false;
            } else {
                document.getElementById('left').checked = true;
            }
        } else {
            if (document.getElementById('right').checked) {
                document.getElementById('left').checked = false;
            } else {
                document.getElementById('right').checked = true;
            }
        }
    }

    componentDidMount() {
        // const player_id = this.props.playerId;
        // this.props.getPlayerBatter(player_id);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.playerInfo) {
                this.setState({
                    showLoading: false,
                    player_id: this.props.playerId,
                    dataDeregis: converdataDeregis(nextProps.playerInfo),
                    dataAchievement: convertDataAchievement(nextProps.playerInfo),
                    dataHotzone: nextProps.playerInfo.hotozone || [],
                    dataPitcher1: convertDataPerformance(nextProps.playerInfo.ball_type_performances),
                    dataPitcher2: converTrouble(nextProps.playerInfo.ordinary_hits_summuries),
                    position: nextProps.position,
                    dataBallDirection: nextProps.playerInfo.batted_ball_direction ? {
                        '3div' : nextProps.playerInfo.batted_ball_direction['3dive'],
                        '5div' : nextProps.playerInfo.batted_ball_direction['5dive'],
                    } : []
                });
            }

            if (nextProps.listYear) {
                this.setState({
                    listYear: nextProps.listYear
                });
            }

            if (nextProps.dataPitcher1) {
                this.setState({
                    dataPitcher1: convertDataPerformance(nextProps.dataPitcher1)
                })
            }
            if (nextProps.dataPitcher2) {
                this.setState({
                    dataPitcher2: converTrouble(nextProps.dataPitcher2)
                })
            }
            if (nextProps.dataHotzone) {
                this.setState({
                    dataHotzone: nextProps.dataHotzone
                })
            }
            if (nextProps.dataBallDirection) {
                this.setState({
                    dataBallDirection: {
                        '3div': nextProps.dataBallDirection['3dive'],
                        '5div': nextProps.dataBallDirection['5dive']
                    }
                })
            }
        }
    }

    render() {
        return (
            <div className="basic-info">
                <div className="table">
                    <div className="block">
                        <Table
                            header={this.props.headerDeregis}
                            titleTable={this.props.titleDeregis}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.dataDeregis}
                            isShowOptionTable={false}
                            showPagination={false}
                        />
                    </div>
                    <div className="block">
                        <Table
                            header={this.props.headerAchievement}
                            titleTable={this.props.titleAchievement}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.dataAchievement}
                            isShowOptionTable={false}
                            showPagination={false}
                        />
                    </div>
                    {/* <div className="block">
                        <Table header={headerPerformance} titleTable={titlePerformance} showCheckbox={false} showSearch={false} itemOfPage={dataPerformance} isShowOptionTable={false} />
                    </div>
                    <div className="block">
                        <Table header={headerBreakdown} titleTable={titleBreakdown} showCheckbox={false} showSearch={false} itemOfPage={dataBreakdown} isShowOptionTable={false} />
                    </div> */}
                </div>

                <div className="table" style={{marginTop: '1rem'}}>
                    {this.state.position == 'batter' &&
                        <>
                            <CardGrid
                                hideOptions={true}
                                title={'ホットゾーン'}
                                data={this.state.dataHotzone}
                                type={GRID}
                                onChangeAction={(action) => {}}
                                onUpdateNote={(note) => {}}
                                onUpdateTitle={(title) => {}}
                                yearOptions={{player_id: this.state.player_id, list: this.state.listYear, getData: this.props.getPlayerBatterHotzone }}
                            />
                            <CardGrid
                                hideOptions={true}
                                title={'打球方向'}
                                data={this.state.dataBallDirection}
                                type={CIRCLE}
                                onChangeAction={(action, type) => {}}
                                onUpdateNote={(note) => {}}
                                onUpdateTitle={(title) => {}}
                                yearOptions={{player_id: this.state.player_id, list: this.state.listYear, getData: this.props.getPlayerBatterBattedBallDirection }}
                            />
                        </>
                    }
                </div>

                {this.state.position == 'pitcher' && <div className="table">
                    <div className="block">
                        <Table
                            header={['球種名', '投球割合', '被打率', '空振り率']}
                            titleTable={{
                                dot: false,
                                text: '球種別投手成績'
                            }}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.dataPitcher1}
                            isShowOptionTable={false}
                            showPagination={false}
                            yearOptions={{player_id: this.state.player_id, list: this.state.listYear, getData: this.props.getPlayerPitcherBallTypePerformances }}
                        />
                    </div>
                    <div className="block">
                        <Table
                            header={['内訳', 'アウト数', '割合']}
                            titleTable={{
                                dot: false,
                                text: 'アウト内訳'
                            }}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.dataPitcher2}
                            isShowOptionTable={false}
                            showPagination={false}
                            yearOptions={{player_id: this.state.player_id, list: this.state.listYear, getData: this.props.getPlayerPitcherOrdinaryHitsSummaries }}
                        />
                    </div>
                </div>}
                <Loading show={this.state.showLoading} />
            </div>
        )
    }
}

const mapStateToProps = ({ players }) => {
    return {
        headerDeregis: players.headerDeregis,
        dataDeregis: players.dataDeregis,
        titleDeregis: players.titleDeregis,
        titleAchievement: players.titleAchievement,
        headerAchievement: players.headerAchievement,
        dataAchievement: players.dataAchievement,
        response: players.response,
        status: players.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getPlayerBatter: (playerId) => {
            dispatch(getPlayerBatter(playerId))
        },
        getPlayerPitcherBallTypePerformances: (player_id, year_id) => {
            dispatch(getPlayerPitcherBallTypePerformances(player_id, year_id));
        },
        getPlayerPitcherOrdinaryHitsSummaries: (player_id, year_id) => {
            dispatch(getPlayerPitcherOrdinaryHitsSummaries(player_id, year_id));
        },
        getPlayerBatterHotzone: (player_id, year_id) => {
            dispatch(getPlayerBatterHotzone(player_id, year_id));
        },
        getPlayerBatterBattedBallDirection: (player_id, year_id) => {
            dispatch(getPlayerBatterBattedBallDirection(player_id, year_id));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(BasicInfomation);
